import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { createBaseChartConfig, type ChartData } from './chartConfigUtils';

interface NonMetalContractCountData {
    date: string;
    count: number;
}

interface NonMetalContractCountChartProps {
    data: NonMetalContractCountData[];
    loading?: boolean;
    referenceValue?: number;
}

const NonMetalContractCountChart: React.FC<NonMetalContractCountChartProps> = ({
    data,
    loading = false,
    referenceValue,
}) => {
    const { t } = useTranslation();

    const chartData: ChartData[] = data.map(d => ({ date: d.date, value: d.count ?? 0 }));
    const options: Highcharts.Options = {
        ...createBaseChartConfig(
            chartData,
            {
                chartType: 'column',
                yAxisTitle: t('statistics.charts.numberOfContracts', 'Number of Contracts'),
                yAxisColor: '#fa8c16',
                seriesName: t(
                    'statistics.charts.nonMetalContractCount',
                    'Non-Metal Contract Count',
                ),
                seriesColor: '#fa8c16',
                referenceValue,
            },
            t,
        ),
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
            },
        },
    };

    if (loading) {
        return (
            <div
                style={{
                    height: 210,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {t('statistics.charts.loading', 'Loading chart...')}
            </div>
        );
    }

    return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default NonMetalContractCountChart;
